import { sanitizeSensitiveUrl } from '@/shared/lib/sanitizeSensitiveUrl'

/**
 * Redacts share tokens and patient UUIDs from URLs before analytics capture (SEC-008 / CRIT-001).
 */
export function sanitizeAnalyticsUrl(href: string): string {
  return sanitizeSensitiveUrl(href)
}
